import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';

const Error = styled(Typography)`
  font-size: 0.75rem;
`;
interface ErrorMessagesProps {
  errors: any;
}
const ErrorMessages = ({ errors }: ErrorMessagesProps) => {
  return errors.map((err: string, index: number) => (
    <Error key={index} variant="copy2" color="punch" m="0.5rem 0">
      {err}
    </Error>
  ));
};

export default ErrorMessages;
